import { STATUS_COLORS } from '../../styles/design-tokens';

export default function StatusBadge({ status, small }) {
  const s = STATUS_COLORS[status] || STATUS_COLORS['Lodged'];
  return (
    <span style={{
      background: s.bg,
      color: s.text,
      fontSize: small ? 11 : 12,
      fontWeight: 600,
      padding: small ? "3px 8px" : "4px 10px",
      borderRadius: 4,
      border: `1px solid ${s.text}22`,
      whiteSpace: "nowrap",
    }}>{status}</span>
  );
}
